module.exports = __webpack_public_path__ + "img/vip.42df6ab2.png";